var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          path: '/dashboard',
          icon: 'ni ni-tv-2 text-primary'
        }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Brands',
                path: '/brands',
                icon: 'ni ni-briefcase-24 text-primary'
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Domains',
                path: '/domains',
                icon: 'ni ni-world-2 text-primary'
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Job Histories',
                path: '/job_histories',
                icon: 'ni ni-collection text-primary'
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Job Groups',
                path: '/job_groups',
                icon: 'ni ni-archive-2 text-primary'
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Job Group Histories',
                path: '/job_group_histories',
                icon: 'ni ni-collection text-primary'
              }}}),_c('sidebar-item',{attrs:{"link":{
                  name:'Location reports',
                  path:'/location_reports',
                  icon:'ni ni-chart-bar-32 text-primary'
                }}}),_c('sidebar-item',{attrs:{"link":{
                  name:'Popularity',
                  path:'/popularity',
                  icon:'ni ni-building text-primary'
                }}}),_c('sidebar-item',{attrs:{"link":{
                  name: 'Login',
                  path: '/login',
                  icon: 'ni ni-key-25 text-primary'
                }}}),_c('sidebar-item',{attrs:{"link":{
                  name: 'Register',
                  path: '/register',
                  icon: 'ni ni-circle-08 text-primary'
                }}}),_c('sidebar-item',{attrs:{"link":{
                  name:'Logout',
                  path:'/logout',
                  icon:'ni ni-button-power text-primary'
                }}})],1)],2),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }